/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Preferences_Load_FailedInputs */



/**
* | output |
* | --- |
* | "We could not load your preferences. Reload the page and try again." |
*
* @param {Onboarding_Preferences_Load_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_preferences_load_failed = /** @type {((inputs?: Onboarding_Preferences_Load_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Preferences_Load_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("We konden je voorkeuren niet laden. Herlaad de pagina en probeer opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nous n'avons pas pu charger vos préférences. Rechargez la page et réessayez.")
	return /** @type {LocalizedString} */ ("We could not load your preferences. Reload the page and try again.")
});